import api from './api';

export interface StartExternalCheckoutResponse {
  subscriptionId: string;
  handoffToken: string;
  checkoutUrl: string;
  plan: 'PREMIUM' | 'PRO';
  amountPaise: number;
  amountInr: string;
  expiresInMinutes: number;
}

export const subscriptionService = {
  /** After PayU return: verify latest pending checkout server-side (webhook fallback). */
  syncPendingCheckout: async (): Promise<{
    activated: boolean;
    plan?: string;
    endDate?: string;
    message?: string;
  }> => {
    const response = await api.post<{
      activated?: boolean;
      plan?: string;
      endDate?: string;
      reason?: string;
      message?: string;
    }>('/api/subscriptions/checkout/sync-pending', {});

    if (response.success && response.data) {
      return {
        activated: Boolean(response.data.activated),
        plan: response.data.plan,
        endDate: response.data.endDate,
        message: response.data.message,
      };
    }
    return { activated: false, message: (response as { error?: string }).error };
  },

  /** Start PRAV-hosted PayU checkout (redirect user to checkoutUrl). */
  startExternalCheckout: async (
    plan: 'PREMIUM' | 'PRO',
    returnUrl?: string
  ): Promise<StartExternalCheckoutResponse> => {
    const response = await api.post<StartExternalCheckoutResponse>(
      '/api/subscriptions/checkout/start-external',
      { plan, returnUrl }
    );
    if (response.success && response.data) return response.data;
    throw new Error((response as { error?: string }).error || 'Failed to start checkout');
  },
};
